import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamationFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29156_5392)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M13.9984 26.5999C20.9572 26.5999 26.5984 20.9587 26.5984 13.9999C26.5984 7.04111 20.9572 1.3999 13.9984 1.3999C7.03965 1.3999 1.39844 7.04111 1.39844 13.9999C1.39844 20.9587 7.03965 26.5999 13.9984 26.5999Z",
				fill: "#E97500",
				stroke: "#E97500",
				strokeWidth: 2.1,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14 15.0502V7.7002",
				stroke: "white",
				strokeWidth: 2.1,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.001 18.2656C14.8345 18.2657 15.5098 18.9419 15.5098 19.7754C15.5097 20.6088 14.8344 21.2841 14.001 21.2842C13.1674 21.2842 12.4913 20.6089 12.4912 19.7754C12.4912 18.9418 13.1674 18.2656 14.001 18.2656Z",
				fill: "white",
				stroke: "white",
				strokeWidth: .13125
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29156_5392",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 28,
			height: 28,
			fill: "white"
		})
	}) })]
});
export default SvgExclamationFilled;
